import { FeApi } from '../../..';
import {
  type JobResult,
  JobResultSchema,
} from '../../../domain/entities/capacity-evaluation';

export function aggregatedResultsMapper(
  data: FeApi.GetJobResultsViewOutput,
): JobResult {
  const result = JobResultSchema.safeParse({
    id: data.accure_id,
    fullFrontendId: data.full_frontend_id,
    chargingEnergy: data.charging_energy,
    dischargingEnergy: data.discharging_energy,
    chargingSohC: data.charging_soh_c,
    dischargingSohC: data.discharging_soh_c,
  });

  if (result.success) {
    return result.data;
  } else {
    console.error('Failed to parse JobResults:', result.error);

    return {
      id: '',
      fullFrontendId: '',
      chargingEnergy: 0,
      dischargingEnergy: 0,
      chargingSohC: 0,
      dischargingSohC: 0,
    };
  }
}
